import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { FIFTEEN_MINUTES, QUERY_KEYS } from '@avanta/shared/constants/common';
import { PsychologistService } from '@avanta/shared/services/psychologists';
import { type Psychologist } from '@avanta/shared/types/psychologists';
import { type AppQueryOptions } from '@avanta/shared/types/queries';

export const fetchPsychologistDetailsQueryOptions = (
  psychologistId: string
): AppQueryOptions<Psychologist, readonly [typeof QUERY_KEYS.FETCH_PSYCHOLOGIST_DETAILS, string]> =>
  queryOptions({
    queryKey: [QUERY_KEYS.FETCH_PSYCHOLOGIST_DETAILS, psychologistId] as const,
    queryFn: async () => (await PsychologistService.getPsychologist(psychologistId)).data,
    staleTime: FIFTEEN_MINUTES,
    gcTime: FIFTEEN_MINUTES,
  });

export const useFetchPsychologistDetails = (
  psychologistId: string
): UseQueryResult<Psychologist, Error> =>
  useQuery({
    ...fetchPsychologistDetailsQueryOptions(psychologistId),
    enabled: Boolean(psychologistId),
  });
